import React from "react";
import About from "../About/About";
import WhyChooseUs from "../WhyChooseUs/WhyChooseUs";
import InhelerForm from "../InhelerForm/InhelerForm";
import Lab from "../Lab/Lab";
import Clients from "../Clients/Clients";
import Introduction from "../Introduction/Introduction";
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

function Home() {
  return (
    <>
    <Header/>
      <div className="Home">
        <Introduction/>
        <Lab/>
        <About/>
        <InhelerForm/>
        <WhyChooseUs/>
        <Clients/>
      </div>
      <Footer/>
    </>
  );
}
export default Home;